const DEFAULT_TIMEOUT_MS = 5000;

export const fetchWithTimeout = async (url, options = {}, timeoutMs = DEFAULT_TIMEOUT_MS) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

  try {
    return await fetch(url, {
      ...options,
      signal: controller.signal,
    });
  } catch (error) {
    if (error.name === "AbortError") {
      throw new Error(`요청 시간 초과 (${timeoutMs}ms): ${url}`);
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
};
